export default "__VITE_ASSET__BIwYWng3__"